import React, { useEffect, useState } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { Spin } from 'antd';
import {
  connectionAccountState,
  notificationsListState,
  searchModeState,
  smallDeviceSearchTriggerState,
} from '../../recoil/atoms';
import { NotificationCard } from '../../components/NotificationCard';
import { backendApiService } from '../../lib/services/BackendApiService';
import SearchResultPage from '../../components/ui/SearchResultPage';

const NotificationsPage = () => {
  const connectionAccount = useRecoilValue(connectionAccountState);
  const notificationsList = useRecoilValue(notificationsListState);
  const setNotificationsList = useSetRecoilState(notificationsListState);
  const [notificationsLoading, setNotificationsLoading] = useState<boolean>(
    false,
  );

  const inSearchMode = useRecoilValue(searchModeState);
  const smallDeviceSearchTrigger = useRecoilValue(
    smallDeviceSearchTriggerState,
  );

  async function onFetchingNotifications() {
    setNotificationsLoading(true);
    const { notifications } = await backendApiService.getNotifications(
      connectionAccount.address,
    );
    setNotificationsLoading(false);

    if (notifications) {
      setNotificationsList(notifications);
    }
  }

  useEffect(() => {
    if (connectionAccount?.address && !notificationsList.length) {
      // Fetching to notifications

      onFetchingNotifications();
    }
  }, [connectionAccount]);

  if (inSearchMode && smallDeviceSearchTrigger) {
    return <SearchResultPage />;
  }

  return (
    <div className="notification-page-content">
      <div className="notification-page-header">
        <h4>Notifications</h4>
      </div>

      {notificationsLoading || !connectionAccount.address ? (
        <div className="home-init-spinner">
          <Spin size="large" />
        </div>
      ) : (
        <div />
      )}

      {!notificationsList.length &&
      !notificationsLoading &&
      connectionAccount.address ? (
        <div className="notification-page-no-items">
          <strong
            style={{
              textAlign: 'center',
              paddingTop: '30px',
              fontSize: '16px',
            }}
          >
            Your notifications will appear here
          </strong>
        </div>
      ) : (
        <div className="notification-page-items">
          {notificationsList.map((notification, index) => (
            <NotificationCard
              key={index.toFixed()}
              notificationData={notification}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default NotificationsPage;
